import createIcon from '../../createIcon';

/**
 * @component @name InvertColors
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgNS4zMVYxOS41QzguNjkgMTkuNSA2IDE2Ljg3IDYgMTMuNjNDNiAxMi4wNyA2LjYyIDEwLjYgNy43NSA5LjQ5TDEyIDUuMzFaTTYuMzUgOC4wNkM0LjkgOS40OSA0IDExLjQ2IDQgMTMuNjNDNCAxNy45OCA3LjU4IDIxLjUgMTIgMjEuNUMxNi40MiAyMS41IDIwIDE3Ljk4IDIwIDEzLjYzQzIwIDExLjQ2IDE5LjEgOS40OSAxNy42NSA4LjA2TDEyIDIuNUw2LjM1IDguMDZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const InvertColors = createIcon('InvertColors', [
  [
    'path',
    {
      d: 'M12 5.31V19.5C8.69 19.5 6 16.87 6 13.63C6 12.07 6.62 10.6 7.75 9.49L12 5.31ZM6.35 8.06C4.9 9.49 4 11.46 4 13.63C4 17.98 7.58 21.5 12 21.5C16.42 21.5 20 17.98 20 13.63C20 11.46 19.1 9.49 17.65 8.06L12 2.5L6.35 8.06Z',
      key: 'm3lmv7',
    },
  ],
]);

export default InvertColors;
